import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-items-white text-main hover:text-secondary-hover heading-s cursor-pointer rounded-full py-1.5 pr-3.5 pl-1.5 transition-colors'
  },
  variants: {
    selected: {
      true: {
        base: 'bg-blue-dark text-main-inversion hover:text-main-inversion'
      }
    },
    disabled: {
      true: {
        base: 'text-inactive cursor-not-allowed'
      }
    }
  }
});
